import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import ServiceQueue from '../types/ServiceQueue';

const getServiceQueuesQuery = graphql(`
  query getServiceQueuesQuery {
    queues {
      items {
        id
        entrypoints
        name
        memberIds
        routingStrategy
        sessions {
          id
          name
          position
          enteredAt
        }
        inboundRecording
        outboundRecording
        inboundAnnounceRecording
        recoveryTime
        agentTimeout
        rolloverSettings {
          timeout
        }
        status {
          abandonedSessions
          activeSessionCount
          averageWait
          longestWait
          missedSessions
          recipientCount
          totalSessions
          activeRecipientCount
          availableRecipientCount
          estimatedWait
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

async function getServiceQueues(): Promise<ServiceQueue[]> {
  const { data, error } = await getClient().query({
    query: getServiceQueuesQuery,
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  // return cloned data as we need to mutate it
  const queues = data?.queues?.items ? structuredClone(data.queues.items) : [];
  return queues;
}

export default getServiceQueues;
